export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/eefb1ec956e8cd3b0816c1975adc5b85.jpg"
          alt="手機展示背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 text-center">
        <a 
          href="https://www.instagram.com/p/DRrWBe-ib_h/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-5 py-2.5 rounded-full mb-8 border border-white/20 hover:bg-white/20 transition-all hover:scale-105 cursor-pointer"
        >
          <span className="text-yellow-400 text-lg">🔥</span>
          <span className="text-white text-sm font-medium">本月限時優惠</span>
        </a>

        <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          找到最適合你的<br />通訊解決方案
        </h1>

        <p className="text-lg lg:text-xl text-white/90 mb-12 max-w-3xl mx-auto">
          門號申辦 | 手機空機 | 配件銷售 | 專業諮詢
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => scrollToSection('consultation')}
            className="bg-black text-white px-8 py-4 rounded-lg text-base font-medium hover:bg-gray-900 transition-all hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            立即諮詢
          </button>
          <button
            onClick={() => scrollToSection('plans')}
            className="bg-white text-gray-900 px-8 py-4 rounded-lg text-base font-medium hover:bg-gray-100 transition-all hover:scale-105 border-2 border-white whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            瀏覽方案
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
